<template>
  <html lang="en">
    <head>
      <meta charset="UTF-8">
      <meta
        http-equiv="X-UA-Compatible"
        content="IE=edge"
      >
      <meta
        v-if="!isMobile"
        name="viewport"
        content="width=device-width, initial-scale=1.0"
      >
      <meta
        v-else
        name="viewport"
        content="width=device-width, initial-scale=0.75"
      >
    </head>
    <body id="berwowBody">
      <SelectionsPage
        v-if="!submitted"
        :class="isMobile ? 'mobile' : ''"
      />
      <ResultPage
        v-else
        :class="isMobile ? 'mobile' : ''"
      />
    </body>
  </html>
</template>

<script lang="ts">
import ResultPage from "@/components/ResultPage.vue";
import SelectionsPage from "@/components/SelectionsPage.vue";
import { storeToRefs } from "pinia";
import { useSelections } from "./store/selections";
import { useRouter } from "vue-router";
import { useRecommendations, useSettings } from "./store";
import { BerwowEvent, emit } from "./helpers";
export default {
  components: {
    ResultPage,
    SelectionsPage,
  },
  setup() {
    const selections = useSelections();
    const { submitted } = storeToRefs(selections);
    const { unsubmit } = selections;
    const { settings } = storeToRefs(useSettings());
    const { report } = storeToRefs(useRecommendations());
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
    useRouter().beforeEach((to, from, next) => {
      if (to.name === "selections-page") {
        if (settings.value?.useWebHistory) unsubmit();
        else emit(BerwowEvent.SettingsLoaded, settings.value);
      }
      if (from.name === "selections-page" && report.value != undefined)
        submitted.value = true;
      next();
    });

    return {
      submitted,
      isMobile,
    };
  },
};
</script>

<style></style>
